import React, { useEffect, useRef } from "react";

export default function Particles() {
    const ref = useRef(null);
    useEffect(() => {
        const cvs = ref.current;
        if (!cvs) return;
        const ctx = cvs.getContext("2d");
        let raf;
        const resize = () => {
            cvs.width = cvs.offsetWidth * window.devicePixelRatio;
            cvs.height = cvs.offsetHeight * window.devicePixelRatio;
        };
        resize();
        window.addEventListener("resize", resize);

        const PARTICLES = Array.from({ length: 70 }, () => ({
            x: Math.random() * cvs.width,
            y: Math.random() * cvs.height,
            r: 0.5 + Math.random() * 2.2,
            vx: (Math.random() - 0.5) * 0.3,
            vy: (Math.random() - 0.5) * 0.3,
            color: Math.random() > 0.5 ? "#7FD93C" : "#4FE0D5",
            alpha: 0.3 + Math.random() * 0.7,
        }));
        const TRAILS = Array.from({ length: 6 }, () => ({
            x: Math.random() * cvs.width,
            y: Math.random() * cvs.height,
            len: 80 + Math.random() * 200,
            speed: 1 + Math.random() * 2,
            angle: Math.random() * Math.PI * 2,
        }));

        const draw = () => {
            ctx.clearRect(0, 0, cvs.width, cvs.height);
            // particles
            PARTICLES.forEach((p) => {
                p.x += p.vx; p.y += p.vy;
                if (p.x < 0) p.x = cvs.width;
                if (p.x > cvs.width) p.x = 0;
                if (p.y < 0) p.y = cvs.height;
                if (p.y > cvs.height) p.y = 0;
                ctx.beginPath();
                ctx.fillStyle = p.color;
                ctx.globalAlpha = p.alpha;
                ctx.shadowColor = p.color;
                ctx.shadowBlur = 12;
                ctx.arc(p.x, p.y, p.r * window.devicePixelRatio, 0, Math.PI * 2);
                ctx.fill();
            });
            ctx.shadowBlur = 0;
            // trails
            TRAILS.forEach((t) => {
                t.x += Math.cos(t.angle) * t.speed;
                t.y += Math.sin(t.angle) * t.speed;
                if (t.x < -t.len || t.x > cvs.width + t.len || t.y < -t.len || t.y > cvs.height + t.len) {
                    t.x = Math.random() * cvs.width;
                    t.y = Math.random() * cvs.height;
                    t.angle = Math.random() * Math.PI * 2;
                }
                const grad = ctx.createLinearGradient(
                    t.x, t.y,
                    t.x - Math.cos(t.angle) * t.len, t.y - Math.sin(t.angle) * t.len
                );
                grad.addColorStop(0, "rgba(127, 217, 60, 0.85)");
                grad.addColorStop(1, "rgba(127, 217, 60, 0)");
                ctx.strokeStyle = grad;
                ctx.lineWidth = 1.5 * window.devicePixelRatio;
                ctx.globalAlpha = 0.85;
                ctx.beginPath();
                ctx.moveTo(t.x, t.y);
                ctx.lineTo(t.x - Math.cos(t.angle) * t.len, t.y - Math.sin(t.angle) * t.len);
                ctx.stroke();
            });
            ctx.globalAlpha = 1;
            raf = requestAnimationFrame(draw);
        };
        draw();
        return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
    }, []);
    return <canvas ref={ref} className="absolute inset-0 w-full h-full" data-testid="particles-canvas" />;
}
